export const termsOfUse = `
 <p>
            This data can be used by third parties as long as the source is
            clearly attributed to @termsOfUsestbTag@, a logo is added to any
            graphs and if online, a link is added back
            <a href=@termsOfUseLink@ target="_blank" rel="noopener noreferrer">
              to this @termsOfUsestbTag@ webpage
            </a>
            . For our terms of use, please see the
            <a
              href="https://www.nationalarchives.gov.uk/doc/open-government-licence/version/3/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Open Government Licence
            </a>
            . Use of the STB EV Charging Infrastructure regional requirements
            tool also indicates your acceptance of
            <a
              href="https://www.transportforthenorth.com/wp-content/uploads/Final-version-Disclaimer-and-Appropriate-Use-EVCI-13082024-1.pdf"
              target="_blank"
              rel="noopener noreferrer"
            >
              this Disclaimer and Appropriate Use Statement
            </a>
            .
          </p>
`
export const termsOfUseCP = `
 <p>
            This data can be used by third parties as long as the source is
            clearly attributed to @termsOfUsestbTag@, a logo is added to any
            graphs and if online, a link is added back
            <a href=@termsOfUseLink@ target="_blank" rel="noopener noreferrer">
              to this @termsOfUsestbTag@ webpage
            </a>
            . For our terms of use, please see the
            <a
              href="https://www.nationalarchives.gov.uk/doc/open-government-licence/version/3/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Open Government Licence
            </a>
            . Use of the STB EV Charging Infrastructure regional requirements
            tool also indicates your acceptance of
            <a
              href="https://www.transportforthenorth.com/wp-content/uploads/Final-version-Disclaimer-and-Appropriate-Use-EVCI-13082024-1.pdf"
              target="_blank"
              rel="noopener noreferrer"
            >
              this Disclaimer and Appropriate Use Statement
            </a>
            .
          </p>
  <p>Chargepoint data provided by Zapmap (click <a
              href="https://www.zap-map.com"
              target="_blank"
              rel="noopener noreferrer"
            >
             here</a> to access the zapmap website).</p>
            <img src="/img/evci/zapmap-logo.png" alt="Zapmap logo" width="175" height="125" />
`